/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingAppointmentCreateConfigurationPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const BookingAppointmentCreateConfigurationPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentCreateConfigurationPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentCreateConfigurationPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentCreateConfigurationPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


